import {
    addPayment,
    deletePayment,
    getListPayment,
    editPayment,
    getDataEmailForPayment,
    getDataExamForPayment,
    confirmPayment,
    rejectPayment
} from "@/store/api";

export const state = {
    listPayment: [],
    createPayRes: [],
    editPayRes: [],
    deletePayRes: [],
    pagination: [],
    dataForEmailPayment: [],
    dataForExamPayment: [],
    confirmPaymentRes: [],
    rejectPaymentRes: []
};

export const getters = {
    listPayment: (state) => state.listPayment,
    createPayRes: (state) => state.createPayRes,
    editPayRes: (state) => state.editPayRes,
    deletePayRes: (state) => state.deletePayRes,
    pagination: (state) => state.pagination,
    getDataEmailForPayment: (state) => state.dataForEmailPayment,
    getDataExamForPayment: (state) => state.dataForExamPayment,
    confirmPaymentRes: (state) => state.confirmPayment,
    rejectPaymentRes: (state) => state.rejectPayment,
};

export const mutations = {
    listPayment(state, data) {
        state.listPayment = data.data.data;
    },
    pagination(state, data) {
        state.pagination = data.data;
    },
    createPayRes(state, data) {
        state.createPayRes = data;
    },
    editPayRes(state, data) {
        state.editPayRes = data;
    },
    deletePayRes(state, data) {
        state.deletePayRes = data;
    },
    dataForExamPayment(state, data) {
        state.dataForExamPayment = data;
    },
    dataForEmailPayment(state, data) {
        state.dataForEmailPayment = data;
    },
    confirmPayment(state, data){
        state.confirmPaymentRes = data
    },
    rejectPayment(state, data){
        state.rejectPaymentRes = data
    }
};

export const actions = {
    async getListPayment({commit}, body) {
        let data = await getListPayment(body);
        commit("listPayment", data);
        commit("pagination", data);
    },
    async addPayment({commit}, params) {
        let data = await addPayment(params);
        commit("createPayRes", data);
    },
    async editPayment({commit}, dataSend) {
        let data = await editPayment(dataSend);
        commit("editPayRes", data);
    },
    async getDataEmail({commit}, dataSend) {
        let data = await getDataEmailForPayment(dataSend);
        commit("dataForEmailPayment", data);
    },
    async getDataExam({commit}, dataSend) {
        let data = await getDataExamForPayment(dataSend);
        commit("dataForExamPayment", data);
    },
    async delPayment({commit}, id) {
        let data = await deletePayment(id);
        commit("deletePayRes", data);
    },
    async confirmPayment({commit}, id) {
        let data = await confirmPayment(id);
        commit("confirmPayment", data);
    },
    async rejectPayment({commit}, id) {
        let data = await rejectPayment(id);
        commit("rejectPayment", data);
    },
};